import type { CustomerFormState } from "~fulfill/customers/customer/components/CustomerForm";

import { type CustomerStateData, DepositRequirementType } from "~/gql/graphqlBase.generated";

export const DEFAULT_SEND_ORDER_EMAILS = true;
export const DEFAULT_SEND_INVOICE_EMAILS = true;

const toCustomerFormState = (customer: CustomerStateData): CustomerFormState => {
	const depositRequirementType = customer.depositRequirementType ?? DepositRequirementType.None;
	return {
		carrier: customer.carrier || "",
		currency: customer.currency,
		customerGroupId: customer.customerGroupId || "",
		customerId: customer.customerId,
		customerTypeId: customer.customerTypeId || "",
		defaultDiscountPercentage: customer.defaultDiscountPercentage ?? null,
		depositRequirementType,
		depositRequirementValue:
			depositRequirementType === DepositRequirementType.None ? null : (customer.depositRequirementValue ?? null),
		description: customer.description,
		erpId: customer.erpId,
		erpPriceGroupId: customer.erpPriceGroupId,
		federalTaxNumber: customer.federalTaxNumber ?? "",
		freightChargeType: customer.freightChargeType ?? null,
		freightChargeValue: customer.freightChargeValue ?? null,
		name: customer.name,
		orderEntryUnit: customer.orderEntryUnit ?? null,
		poRequired: customer.poRequired,
		priceEntryUnit: customer.priceEntryUnit ?? null,
		priceGroupId: customer.priceGroupId,
		receivingWindowEnd: customer.receivingWindowEnd ?? null,
		receivingWindowStart: customer.receivingWindowStart ?? null,
		route: customer.route || "",
		sendInvoiceEmails: customer.sendInvoiceEmails ?? DEFAULT_SEND_INVOICE_EMAILS,
		sendOrderEmails: customer.sendOrderEmails ?? DEFAULT_SEND_ORDER_EMAILS,
		statementDeliveryMethod: customer.statementDeliveryMethod ?? null,
		statementSkipZeroBalance: customer.statementSkipZeroBalance ?? false,
		taxExemptNumber: customer.taxExemptNumber ?? "",
		termsId: customer.termsId || "",
		unloadMinutes: customer.unloadMinutes ?? null
	};
};

export default toCustomerFormState;
